module.exports = __webpack_public_path__ + "img/slider4.b5b1bfd6.jpg";